import React from 'react';
import { boardService, priorEngagements, governanceMemberships } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
export function BoardServicePage() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-84" data-mp="wc3jah6g6wxc">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-85" data-mp="wcvhlzrfj8rb">
        <PageHeader overline="Board & Advisory Service" title="Board service and advisory roles" description="Current seats span venture, enterprise learning, and evidence-based healthcare design — with governance practice kept current through the director community." data-id="element-86" data-mp="rc7nv6btgdte" />

        <div className="mt-14 grid gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-87" data-mp="1f0s12u9mwm4w">
          {boardService.map(seat => <article key={seat.organization} className="flex flex-col bg-parchment-light p-8" data-id="element-88" data-mp="1b101v864rsc7">
              <h2 className="font-display text-xl leading-snug text-navy" data-id="element-89" data-mp="1p10yucj9yfme">{seat.organization}</h2>
              <p className="mt-3 font-sans text-sm font-medium text-emerald" data-id="element-90" data-mp="1k2hbq8sy2xsg">{seat.role}</p>
              {seat.note && <p className="mt-auto pt-6 font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-91" data-mp="gezdyyadp9hq">
                  {seat.note}
                </p>}
            </article>)}
        </div>

        <div className="mt-16 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-92" data-mp="qdf694l56ost">
          <div data-id="element-93" data-mp="ue7fvyxxevpm">
            <h2 className="font-display text-2xl text-navy" data-id="element-94" data-mp="uajk0t50dx7q">Prior engagements</h2>
            <ul className="mt-6 space-y-5" data-id="element-95" data-mp="zb7ke5f4nqem">
              {priorEngagements.map(seat => <li key={seat.organization} className="flex flex-wrap items-baseline gap-x-4 gap-y-1" data-id="element-96" data-mp="149948skdntr5">
                  <span className="font-sans text-[17px] font-medium text-navy" data-id="element-97" data-mp="19227td440w1n">
                    {seat.organization}
                  </span>
                  <span className="font-sans text-sm text-navy-400" data-id="element-98" data-mp="1i2i9ch1alt3v">{seat.role}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-emerald-50 p-8" data-id="element-99" data-mp="1n1ut2swvak28">
            <h2 className="font-display text-2xl text-navy" data-id="element-100" data-mp="3j46mpx2zxl69">Governance membership</h2>
            {governanceMemberships.map(seat => <div key={seat.organization} className="mt-6" data-id="element-101" data-mp="3f45w7e2mhjiu">
                <p className="font-sans text-[17px] font-medium text-navy" data-id="element-102" data-mp="3stzpq9p2oryw">{seat.organization}</p>
                <p className="mt-2 font-sans text-sm font-medium text-emerald" data-id="element-103" data-mp="3o3szy6itr1f2">{seat.role}</p>
                {seat.note && <p className="mt-4 font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-104" data-mp="6m04d4x1gvxp">
                    {seat.note}
                  </p>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}